<template>
<div
    :class="{
        'CompatibilityChecker': 1,
        'CompatibilityChecker--compatible': resolved && compatible,
        'CompatibilityChecker--notCompatible': resolved && !compatible,
    }">
    <template v-if="resolved">
        <template v-if="compatible">
            <p>
                This product is compatible with your {{ selectedModelLabel }} {{ selectedYear }}.
            </p>
            <button
                @click="onReset"
                class="CompatibilityChecker__Reset">
                Pick a different vehicle
            </button>
        </template>
        <template v-else>
            <p>
                This product may not be compatible with your car. Please check the compatibility list below.
            </p>
            <button
                @click="onReset"
                class="CompatibilityChecker__Reset">
                Pick a different vehicle
            </button>
        </template>
    </template>
    <template v-else>
        <p>
            This product is <strong>ONLY</strong> compatable with the vehicles in this list. To make sure that your vehicle is compatible search your vehicle information below.
        </p>
        <div class="CompatibilityChecker__Lookup">
            <div class="CompatibilityChecker__Fields">
                <div class="CompatibilityChecker__Field">
                    <div class="CompatibilityChecker__SelectWrapper">
                        <select
                            v-model="selectedModel"
                            class="CompatibilityChecker__Input">
                            <option :value="null">
                                MODEL
                            </option>
                            <option
                                v-for="model in Object.values(modelTree)"
                                :key="model.value"
                                :value="model.value">
                                {{ model.label }}
                            </option>
                        </select>
                        <span
                            v-html="iconChevronUp"
                            class="CompatibilityChecker__SelectCaret"/>
                    </div>
                </div>
                <div class="CompatibilityChecker__Field">
                    <div class="CompatibilityChecker__SelectWrapper">
                        <select
                            v-model="selectedYear"
                            :disabled="!selectedModel"
                            class="CompatibilityChecker__Input">
                            <option :value="null">
                                YEAR
                            </option>
                            <option
                                v-for="year in yearOptions"
                                :key="year"
                                :value="year">
                                {{ year }}
                            </option>
                        </select>
                        <span
                            v-html="iconChevronUp"
                            class="CompatibilityChecker__SelectCaret"/>
                    </div>
                </div>
            </div>
            <button
                @click="onCheckVehicle"
                :disabled="!selectedModel || !selectedYear"
                class="CompatibilityChecker__Submit">
                Check Compatibility
            </button>
        </div>
    </template>
</div>
</template>

<script>
import iconChevronUp from '@icons/icon_chevron_up.svg'

export default {
    props: {
        modelTree: Object,
        compatibleTags: Array
    },
    data () {
        return {
            iconChevronUp,

            resolved: false,
            selectedModel: null,
            selectedYear: null
        }
    },
    computed: {
        yearOptions () {
            if (!this.selectedModel) {
                return []
            }
            return this.modelTree[this.selectedModel].years
        },
        compatible () {
            if (!this.selectedModel || !this.selectedYear) {
                return false
            }

            const replaceString = (window.theme.store.id === 'de_store') ? '-Aktuell' : '-Present'
            const year = this.selectedYear.split(/\s/).join('').replace(replaceString, '')
            const model = this.selectedModel

            const modelTag = `${model}_${year}`
            return this.compatibleTags.indexOf(modelTag) > -1
        },
        selectedModelLabel () {
            return this.modelTree[this.selectedModel].label
        }
    },
    watch: {
        selectedModel () {
            this.selectedYear = null
        }
    },
    methods: {
        onCheckVehicle () {
            this.resolved = true
        },
        onReset () {
            this.selectedModel = null
            this.selectedYear = null
            this.resolved = false
        }
    }
}
</script>

<style lang="scss">
$mobileBreakpoint: 768px;
$smallDesktopBreakpoint: 1024px;

.CompatibilityChecker {
    padding: 20px 60px;

    @media screen and (max-width: $smallDesktopBreakpoint) {
        padding: 30px 15px;
    }

    color: white;
    background-color: #2861a4;
    &--notCompatible {
        background-color: #da7029;
    }
    &--compatible {
        background-color: #36941c;
    }

    p {
        color: white;
    }

    &__Lookup {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        @media screen and (max-width: $mobileBreakpoint) {
            width: 100%;
            flex-direction: column;
            align-items: stretch;
        }
    }
    &__Fields {
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);

        display: flex;
        align-items: center;
        flex-wrap: wrap;

        @media screen and (max-width: $mobileBreakpoint) {
            width: 100%;
            flex-direction: column;
            align-items: stretch;
        }
    }
    &__Field {
        vertical-align: middle;
        height: 100%;
        min-height: 72px;
        min-width: 260px;
    }
    &__Input {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;

        width: 100%;
        min-width: 100%;

        line-height: 72px;
        min-height: 72px;

        background: white;
        border: 1px solid #979797;
        border-radius: 0;

        text-transform: uppercase;
        font-size: 12px;

        padding: 0 30px;

        cursor: pointer;

        &:disabled {
            opacity: 0.4;
        }

        &:focus {
            border: 1px solid #102b4e;
        }
    }

    &__SelectWrapper {
        position: relative;
    }
    &__SelectCaret {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%) rotate(180deg);

        display: flex;
        align-items: center;
        justify-content: center;

        color: #102b4e;
    }
    &__Input {
        padding-right: 45px;
    }

    &__Submit,
    &__Reset {
        margin: 10px;

        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;

        border: none;
        background: none;
        outline: none;

        padding: 12px 40px;
        background-color: #ffffff;
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1), 0 20px 20px rgba(0, 0, 0, 0.1);
        border-radius: 20px;

        color: #102b4e;
        font-size: 18px;
        line-height: 13px;

        @media screen and (max-width: $mobileBreakpoint) {
            margin-left: auto;
            margin-right: auto;
        }
    }

    &__Reset {
        font-size: 14px;
        margin: 0;

        @media screen and (max-width: $mobileBreakpoint) {
            margin: 0 auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// CompatibilityChecker.vue?37435fd1